import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const PanipuravthaInfoService = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    return (
        <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
            {/* Header */}
            <div className="max-w-7xl mx-auto mb-10">
                <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 backdrop-blur-sm"
                        >
                            <FiArrowLeft className="w-6 h-6" />
                        </button>
                        <div>
                            <h1 className="text-2xl md:text-3xl font-bold mb-1">पाणिपुरवठा माहिती सुविधा</h1>
                            <p className="text-slate-300 text-sm">
                                {grampanchayatName || 'ग्रामपंचायत'} | आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content with Icons */}
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-[50vh] gap-16 md:gap-32">
                    
                    {/* Item 1: Panipuravtha Mahiti */}
                    <div className="flex flex-col items-center group cursor-pointer">
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-black text-white flex items-center justify-center mb-4 shadow-xl group-hover:scale-110 transition-transform duration-300">
                             <span className="text-5xl md:text-6xl font-serif font-bold italic">i</span>
                        </div>
                        <h2 className="text-lg md:text-xl text-black font-medium group-hover:text-blue-600 transition-colors">पाणिपुरवठा माहिती</h2>
                    </div>

                    {/* Item 2: Karanchi Mahiti */}
                    <div 
                        className="flex flex-col items-center group cursor-pointer"
                        onClick={() => navigate('/panipuravtha/tax-info', { state: location.state })}
                    >
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-black text-white flex items-center justify-center mb-4 shadow-xl group-hover:scale-110 transition-transform duration-300">
                             <span className="text-5xl md:text-6xl font-serif font-bold italic">i</span>
                        </div>
                        <h2 className="text-lg md:text-xl text-black font-medium group-hover:text-blue-600 transition-colors">करांची माहिती</h2>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PanipuravthaInfoService;
